import React, { useState, ReactNode } from "react";
import HeaderSection from "./header";
import FooterSection from "./footer";
import SidebarSection from "./sidebar";
import { Outlet } from "react-router-dom";
import "./layout.css";
import { LoginRootState } from "../../types/login";
import { useAppSelector } from "../../globalState/hooks";
import ChatBot from "../../components/ChatBot";

interface LayoutProps {
  children?: ReactNode;
}

const Layout: React.FC<LayoutProps> = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };
  const userDetails = useAppSelector(
    (state: LoginRootState) => state.authReducer.loginDetials
  );
  const excludedDesignations = ["Intern"];
  const isExcludedDesignation = excludedDesignations.includes(
    userDetails?.designation
  );
  return (
    <React.Fragment>
      <div className={`layout ${isSidebarOpen ? "sidebar-active" : ""}`}>
        <div className="header">
          <HeaderSection onMenuClick={toggleSidebar} />
        </div>

        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <SidebarSection />
        </div>

        {/* Gray-out background overlay */}
        {isSidebarOpen && (
          <div className="overlay" onClick={() => setSidebarOpen(false)}></div>
        )}

        <div className="main-container">
          <div className="content">
            <Outlet />
          </div>
          {(userDetails?.country === "India" ||
            userDetails?.country === "UK") &&
            !isExcludedDesignation && <ChatBot />}
        </div>

        <div className="footer">
          <FooterSection />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Layout;
